import { render, staticRenderFns } from "./_CustomBranch.vue?vue&type=template&id=61bbc239&"
import script from "./_CustomBranch.vue?vue&type=script&lang=js&"
export * from "./_CustomBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports